import { Component, inject } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NavbarPrimaryComponent } from '../../components/navbar-primary/navbar-primary.component';
import { FooterPrimaryComponent } from '../../components/footer-primary/footer-primary.component';
import {
  FooterContentService,
  FooterDocument
} from '../../services/footer-content.service';

@Component({
  selector: 'app-integrity',
  imports: [RouterLink, NavbarPrimaryComponent, FooterPrimaryComponent],
  templateUrl: './integrity.component.html',
  styles: `
    :host {
      height: 100vh;
      display: flex;
      flex-direction: column;
    }

    main {
      flex: 1;
      padding-top: 64px;
    }
  `
})
export class IntegrityComponent {
  private readonly footerContent = inject(FooterContentService);

  buttonCollapsed: boolean[] = [];

  files: FooterDocument[] = [];
  loading = true;
  error = false;

  constructor() {
    this.footerContent.getDocuments('integrity').subscribe({
      next: (files) => {
        this.files = files;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
